import { addTrackingData, generalCallbacks } from './general';
const offerModifierCallback = (callbackData) => {
    const data = generalCallbacks.submitModifierCallback(callbackData);
    if (data === null) {
        return null;
    }
    data.customer_comments_c = '';
    if (data.language) {
        data.customer_comments_c += 'In welchen Sprachen sollen wir Ihre Anrufe annehmen? :' + data.language;
    }
    delete data.language;
    return addTrackingData(data);
};
export const offerCallbacks = {
    offerModifierCallback,
};
